import { createBrowserClient } from "@supabase/ssr";

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    "Supabase env vars missing: set NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY",
  );
}

/**
 * Browser client — PKCE + cookies (`@supabase/ssr`) so OAuth (Google, Apple) and SSR stay in sync.
 * Email confirmation / recovery should use `getAuthRedirectTo()` → `/auth/callback?next=…` so the
 * server route exchanges `?code=`; hash-only implicit links are not used with PKCE clients.
 */
export const supabase =
  supabaseUrl && supabaseAnonKey ? createBrowserClient(supabaseUrl, supabaseAnonKey) : null;

/**
 * Best-effort browser cleanup for auth keys after explicit logout.
 * Supabase already clears session on signOut; this additionally removes
 * any leftover storage keys so returning users always re-authenticate.
 */
export function clearSupabaseAuthStorage(): void {
  if (typeof window === "undefined") return;
  const wipe = (store: Storage | undefined) => {
    if (!store) return;
    const keys: string[] = [];
    for (let i = 0; i < store.length; i += 1) {
      const k = store.key(i);
      if (!k) continue;
      if (k.startsWith("sb-") || k.includes("-auth-token")) keys.push(k);
    }
    for (const k of keys) store.removeItem(k);
  };
  wipe(window.localStorage);
  wipe(window.sessionStorage);
}
